// @flow
import { createContext, useContext } from 'react';
import axios from 'axios';
import type { ModalConfigType } from '../types';

// This file is extracted to avoid an unnecessary dependency cycle from Link to Modal
export type ModalContextType = {
  [string]: ModalConfigType
};

type ToggleModalFunctionType = (
  modalId: string,
  isAutoModalEvent?: boolean,
  modalDynamicOptions?: Object
) => void;

type ContextType = {
  openModals: string[],
  toggleModal: ToggleModalFunctionType
};

export const ModalContext = createContext<ContextType>({
  openModals: [],
  toggleModal: () => {}
});

export function getToggleModal(): ToggleModalFunctionType {
  const { toggleModal } = useContext(ModalContext);
  return toggleModal;
}

const configCache = {};
const configPromises = {};

export function getModal(modalId: string, fixedConfigs: ModalContextType = {}) {
  const config = fixedConfigs[modalId] || configCache[modalId];
  if (!config) {
    console.error(`Missing modal definition for ${modalId}`);
    console.error(
      'Available modals are;',
      Object.keys(fixedConfigs).concat(Object.keys(configCache))
    );
    return null;
  }
  return config;
}

export function loadCachedModal(modalId: string): Promise<ModalConfigType> {
  if (configCache[modalId]) {
    return Promise.resolve(configCache[modalId]);
  }
  if (!configPromises[modalId]) {
    let dataPath = `/modal-data/${modalId}/modal-data.json`;
    if (CONFIG.appVersion !== 'development') {
      dataPath = `${CONFIG.assetFolder}${dataPath}`;
    }
    configPromises[modalId] = axios.get(dataPath).then((data) => {
      configCache[modalId] = data.data;
      return data.data;
    });
  }
  return configPromises[modalId];
}
